export default "__VITE_ASSET__BLwFKDEv__"